/* eslint-disable @typescript-eslint/no-explicit-any */
import CustomTable from 'components/cmn/CustomTable';
import { AccountManageTableHead } from 'components/cmn/CustomTableHeadWrapper';
import { useProject } from 'hooks/useProject';
import { memo, useEffect, useMemo } from 'react';
import AccountManageTableBody from './AccountManageTableBody';

function AccountManageTable(): JSX.Element {
  const { getCompAccounts, accountsListSearchCondition, changeCmnPageAndSize } = useProject();
  const { data, isLoading, duration, mutate } = getCompAccounts();
  const { page, size } = accountsListSearchCondition;

  const accountsData = useMemo(() => {
    return data?.contents || [];
  }, [data?.contents]);

  const totalCount = useMemo(() => {
    return data?.totalCount ?? 0;
  }, [data?.totalCount]);

  const handleChangePage = (event: unknown, newPage: number): any => {
    changeCmnPageAndSize('accountsListSearchCondition', newPage, size);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const _rowsPerPage = parseInt(event.target.value, 10);
    changeCmnPageAndSize('accountsListSearchCondition', 0, _rowsPerPage);
  };

  useEffect(() => {
    if (page !== 0 && totalCount !== 0 && accountsData.length === 0) {
      changeCmnPageAndSize('accountsListSearchCondition', page - 1, size);
    }
  }, [changeCmnPageAndSize, page, accountsData.length, size, totalCount]);

  return (
    <CustomTable
      count={totalCount}
      rowsPerPage={size}
      page={page}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      isLoading={isLoading}
      maxHeight="calc(100vh - 385px)"
      duration={duration}
    >
      <AccountManageTableHead order="desc" orderBy="id" />
      <AccountManageTableBody loading={isLoading} rows={accountsData} duration={duration} mutate={mutate} />
    </CustomTable>
  );
}

export default memo(AccountManageTable);
